import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { CandidateService } from '../services/candidate.service';
import { Router } from '@angular/router';
import { JobShareService } from '../home/available-jobs/job-share.service';

@Component({
  selector: 'app-job-landing',
  templateUrl: './job-landing.component.html',
  styleUrl: './job-landing.component.scss'
})
export class JobLandingComponent {
  jobsList: any = []

  stats = [
    {
      icon: 'bi-briefcase-fill',
      value: 10000,
      label: 'Jobs Posted',
      color: 'purple',
      displayValue: 0
    },
    {
      icon: 'bi-envelope-fill',
      value: 5000,
      label: 'Companies Hiring',
      color: 'orange',
      displayValue: 0
    },
    {
      icon: 'bi-check-circle-fill',
      value: 1200,
      label: 'Success Rate',
      color: 'blue',
      displayValue: 0
    },
    {
      icon: 'bi-globe',
      value: 250,
      label: 'Countries',
      color: 'violet',
      displayValue: 0
    }
  ];
currentYear = new Date().getFullYear();
  faqsList:any =[];
  constructor(
    private candidateService: CandidateService,
    private router: Router,
    private jobShare: JobShareService,
    private ngZone: NgZone
  ) {
    this.getAllJobs()
    this.faqsList = [
    {
      id: 1,
      title: 'How do I create an account on the job portal?',
      description: 'NeoJobz allows both vendors and jobseekers to create their account on website. Moreover, jobseekers can create their account on Mobile App too. To create an account, click on the "Register" button on the homepage. You will be prompted to enter your name, email address, phone number, and create a password. Once you havve completed the form, click the submit button. Then you will be prompted to Login or Purchase a Plan..'
    },
    
    {
      id: 2,
      title: 'How can I search for jobs on the portal?',
      description: 'To search for various jobs available on NeoJobz, jobseekers either can download NeoJobz App and register there or on the NeoJobz website, login and explore for suitable jobs.'
    },
    {
      id: 3,
      title: 'How do I apply for a job?',
      description: 'To apply for a job available on NeoJobz, jobseekers are requested to download NeoJobz App or visit NeoJobz website and register there, login, explore for suitable jobs, and apply.'
    },
    {
      id: 4,
      title: 'What should I do if I forget my password?',
      description: 'If you forget your password, click on the "Forgot Password" link on the login page. You will be asked to enter your email address, and a password reset link will be sent to your email id. Follow the instructions in the email to reset your password..'
    },
    {
      id: 5,
      title: 'How can I contact customer support if I need help?',
      description: 'You can contact customer support by calling us or emailing us using the details given at the bottom of the homepage. You may even contact us through "Contact Us" page given in the menu at the top of the homepage. Fill out the contact form with your query, and submit. One of our teammates with get in touch with you shortly.'
    },
    {
      id: 6,
      title: 'Can I apply for jobs without registering on the portal?',
      description: 'Yes, you can. All you have to do is DOWNLOAD NeoJobz App on your smartphone, register there, Login, explore for suitable jobs, and apply. This allows you to track your applications, receive job alerts, and much more.'
    },
    {
      id: 7,
      title: 'What types of jobs can I find on NeoJobz?',
      description: 'NeoJobz offers a wide range of job listings across various industries, including technology, healthcare, finance, education, marketing, retail, and more. You can find full-time, part-time, freelance, internship, volunteer, and remote job opportunities. All you have to do is to DOWNLOAD our App and explore there.'
    },



  ];
  }
  goTo(path: string): void {
  this.router.navigate([path]);
}

  ngAfterViewInit() {
    setTimeout(() => {
      this.stats.forEach(stat => this.animateCount(stat));
    }, 0);
  }

  animateCount(stat: any) {
  const duration = 8000; // 🔥 6 seconds now
    const startTime = performance.now();

    this.ngZone.runOutsideAngular(() => {

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const value = Math.floor(progress * stat.value);

        this.ngZone.run(() => {
          stat.displayValue = value;
        });

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    });
  }


  getAllJobs() {
    let reqObj = {
      // uuid: this.vendorData.uuid,
    };


    this.candidateService.getAllJobs(reqObj).subscribe((response) => {
      console.log("jobbbb", response)
      this.jobsList = response.data;
      // this.jobLocations = response.data
    });
  }

  getAvatarImageUrl(obj: any): string {
    if (obj.companyDetails.logo_path && obj.companyDetails.logo_name && obj.companyDetails.logo_path !== "NA" && obj.companyDetails.logo_name !== "NA") {
      return `${obj.companyDetails.logo_path}/${obj.companyDetails.logo_name}`;
    } else {
      return "assets/images/no-logo.jpg"; // Default placeholder image URL
    }
  }

  goToJob(j: any) {
    this.jobShare.setJob(j);
    this.router.navigate(['job-details'])
  }

  getCommaSeparatedLocations(obj: any): string {
    //console.log("locations", obj)
    if (obj?.locations?.length > 0) {
      return obj.locations.slice(0, 1).map((location: any) => location.branch?.city_name || "").join(", ");
    }
    return "";
  }



  formatSalary(job: any): string {
    if (!job) return '';

    const min = this.salaryFormat(job.min_salary);
    const max = this.salaryFormat(job.max_salary);
    const type = job.salary_type || '';
    const frequency = this.frequencyLabel(job.package_label);

    return `₹${min}${type} - ₹${max}${type} / ${frequency}`;
  }

  salaryFormat(value: number | string): string {
    if (!value) return '';

    const salary = Number(value);
    if (isNaN(salary)) return '';

    // Crores
    if (salary >= 10000000) {
      return (salary / 10000000).toFixed(
        salary % 10000000 === 0 ? 0 : 1
      ) + 'Cr';
    }

    // Lakhs
    if (salary >= 100000) {
      return (salary / 100000).toFixed(
        salary % 100000 === 0 ? 0 : 1
      ) + 'L';
    }

    // Thousands
    if (salary >= 1000) {
      return (salary / 1000).toFixed(
        salary % 1000 === 0 ? 0 : 1
      ) + 'K';
    }

    return salary.toString();
  }

  frequencyLabel(value: string): string {
    if (!value) return '';


    switch (value) {
      case 'Y':
        return 'Yearly';

      case 'M':
        return 'Monthly';

      case 'W':
        return 'Weekly';

      case 'D':
        return 'Daily';

      case 'H':
        return 'Hourly';

      default:
        return value; // return original if no match
    }
  }
}
